import { useTranslate } from "@opensea/next-translate"
import { SmartphoneFilled, Password } from "@opensea/ui-kit/icons"
import React, { useState } from "react"
import { Modal } from "@/design-system/Modal"
import { useGlobalModal } from "@/providers/GlobalModal"
import { ManageSmsCodeStep } from "./components/ManageSmsCodeStep.react"
import { ManageSmsModalBody } from "./components/ManageSmsModalBody.react"
import { ManageSmsPhoneStep } from "./components/ManageSmsPhoneStep.react"

type Props = {
  isEdit: boolean
  onClose: () => void
}

const SMS_ENROLLMENT_STEPS = ["phoneNumber", "smsAuthCode"] as const

type EnrollmentStep = (typeof SMS_ENROLLMENT_STEPS)[number]

export function ManageSmsModal({ isEdit, onClose }: Props) {
  const t = useTranslate("mfa")
  const { closeModal, onPrevious } = useGlobalModal()
  const [step, setStep] = useState<EnrollmentStep>(SMS_ENROLLMENT_STEPS[0])
  const [phoneNumber, setPhoneNumber] = useState("")

  const isFirstStep = step === "phoneNumber"
  const icon = isFirstStep ? (
    <SmartphoneFilled size={50} />
  ) : (
    <Password size={50} />
  )
  const getHeading = () => {
    if (isFirstStep) {
      return isEdit
        ? t(
            "enrollment.sms.editPhone",
            "Provide a new phone number for authentication",
          )
        : t("enrollment.sms.enterPhone", "Enter your phone  number")
    }
    return t("enrollment.sms.enterCode", "Enter authentication code")
  }
  const body = isFirstStep
    ? undefined
    : t("enrollment.sms.sentTo", "Sent to {{phoneNumber}}", {
        phoneNumber,
      })

  return (
    <>
      <Modal.Header
        currentStep={isFirstStep ? 0 : 1}
        onClose={onClose}
        steps={SMS_ENROLLMENT_STEPS.length}
        title={
          isEdit
            ? t("enrollment.sms.modal.editHeader", "Edit SMS")
            : t("enrollment.sms.modal.setupHeader", "Set up SMS")
        }
      />
      <ManageSmsModalBody body={body} heading={getHeading()} icon={icon}>
        {isFirstStep ? (
          <ManageSmsPhoneStep
            onPhoneNumber={p => {
              setPhoneNumber(p)
              setStep("smsAuthCode")
            }}
          />
        ) : (
          <ManageSmsCodeStep
            onVerified={() => {
              // we only open this from MfaMethodsModal, so we should always have onPrevious
              onPrevious?.() ?? closeModal()
            }}
            phoneNumber={phoneNumber}
          />
        )}
      </ManageSmsModalBody>
    </>
  )
}
